import React, { useState } from 'react';
import useUserStore from '../../../services/useUserStore';

const DeleteUserDialog = ({ user, onClose, onSuccess }) => {
  const { deleteUser } = useUserStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);

    try {
      await deleteUser(user.id);
      onSuccess();
    } catch (err) {
      const errorMessage = err.response?.data?.error || 'Falha ao excluir usuário. Tente novamente.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Confirmar Exclusão</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {error && (
            <div className="co-error" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <div className="alert-warning">
            <strong>Atenção!</strong>
            <p>
              Você tem certeza que deseja excluir o usuário <strong>{user.name}</strong>?
            </p>
            <p style={{ marginTop: '0.5rem' }}>
              Esta ação não pode ser desfeita.
            </p>
          </div>

          <div className="alert-warning" style={{ backgroundColor: '#fff3cd', marginTop: '1rem' }}>
            <strong>Nota importante:</strong>
            <p style={{ marginTop: '0.5rem', marginBottom: 0 }}>
              Esta ação pode deixar leads, notas e outros dados associados a este usuário órfãos.
              Considere reatribuir os dados antes de excluir.
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Excluindo...' : 'Confirmar Exclusão'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteUserDialog;
